// src/beta/services/anchor.ts
import { betaFetch } from '@/beta/services/api';
import type { V1Anchor } from '@/beta/types/dossier';

interface Resp { version: 1; vehicle_id: string; data: V1Anchor; generated_at: string; }

/** GET /v1/vehicles/[id]/anchor.
 *  Vehicles that have not been merkle-anchored return 404 — we map that to `null`
 *  so the dossier section can render an "Not anchored" graceful state. */
export async function getAnchor(vehicleId: string): Promise<V1Anchor | null> {
  try {
    const res = await betaFetch<Resp>(`/vehicles/${vehicleId}/anchor`);
    return res.data;
  } catch (err) {
    if ((err as { status?: number }).status === 404) return null;
    throw err;
  }
}
